export { default } from './top-rated-categories';
